import {axios} from '@http_client';
import cookie from "react-cookies";
import User, {getUserInfo} from "./user";

/**
 *
 * @param {object} data => {username, verification_code, type, city_id, district_id, last_name, agency_name}
 *
 * @returns {Promise<User>}
 */
function register(data) {
    const path = 'v1/users/register';

    return new Promise((resolve, reject) => {
        axios.post(path, data).then(response => {
            resolve({
                user: User.make(response.data.user ?? {}),
                auth_token: response.data.auth_token
            });
        }).catch(error => {
            reject(error);
        });
    });
}

/**
 *
 * @param {object} data => {username, password, captchaCode = ""}
 *
 * @returns {Promise<User>}
 */
function loginByPassword(data) {
    const path = "v1/users/loginByPassword";

    return new Promise((resolve, reject) => {
        axios.post(path, data).then(response => {
            resolve({
                user: User.make(response.data.user ?? {}),
                auth_token: response.data.auth_token
            });
        }).catch(error => {
            reject(error);
        });
    });
}

/**
 *
 * @param {string} username
 * @param {string} verificationCode
 * @param {number} captchaCode
 *
 * @returns {Promise<User>}
 */
function loginByVerificationCode(username, verificationCode, captchaCode = "") {
    const path = "v1/users/loginByVerificationCode";
    const data = {
        username: username,
        verification_code: verificationCode,
        captcha_code: captchaCode
    };

    return new Promise((resolve, reject) => {
        axios.post(path, data).then(response => {
            resolve({
                user: User.make(response.data.user ?? {}),
                auth_token: response.data.auth_token
            });
        }).catch(error => {
            reject(error);
        });
    });
}


function loginByToken() {
    return new Promise((resolve, reject) => {
        getUserInfo().then(user => {
            resolve(user)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param {object} params => {mobile || email}
 *
 * * @returns {Promise}
 * */
function sendVerificationCode(params) {
    const path = '/v1/verifications/send';

    return new Promise((resolve, reject) => {
        axios.post(path, params).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    })
}

function logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('auth_token');
    cookie.remove('auth_token', {path: '/'});
    cookie.remove('manishen_session', {path: '/'});
}

export {
    register,
    loginByPassword,
    loginByVerificationCode,
    loginByToken,
    sendVerificationCode,
    logout
}